module.exports = __webpack_public_path__ + "static/img/icon_my_pencel.b5f32ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_my_pencel.svg
// module id = H8hL
// module chunks = 10